import { render, staticRenderFns } from "./LeonidaPrenotazioneList.vue?vue&type=template&id=4109b78d"
import script from "./LeonidaPrenotazioneList.vue?vue&type=script&lang=js"
export * from "./LeonidaPrenotazioneList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports